import React, { useState, useEffect } from "react";
import "./Cookie.css";
import icon from "../../assets/cookie.svg";
import privacyPolicy from "../../assets/documents/Privacy-Policy.pdf";

const Cookie = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieConsent = localStorage.getItem("cookieConsent");
        if (!cookieConsent) {
            setIsVisible(true);
        } else if (cookieConsent === "allowed") {
            loadTrackingScripts();
        }
    }, []);

    const handleAllow = () => {
        localStorage.setItem("cookieConsent", "allowed");
        loadTrackingScripts();
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem("cookieConsent", "declined");
        setIsVisible(false);
    };

    const loadTrackingScripts = () => {
        loadGoogleAnalytics();
        loadFacebookPixel();
    };

    const loadGoogleAnalytics = () => {
        if (!window.gtag) {
            const gtagScript = document.createElement("script");
            gtagScript.async = true;
            gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-43JQ6FDFTN";
            document.head.appendChild(gtagScript);

            gtagScript.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    window.dataLayer.push(arguments);
                }
                window.gtag = gtag;
                gtag("js", new Date());
                gtag("config", "G-43JQ6FDFTN");
            };

            gtagScript.onerror = () => {
                console.error("Failed to load Google Analytics script.");
            };
        }
    };

    const loadFacebookPixel = () => {
        if (!window.fbq) {
            // Initialize fbq before loading the script
            (function(f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function() {
                    n.callMethod
                        ? n.callMethod.apply(n, arguments)
                        : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = true;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            // Initialize Facebook Pixel with your ID
            window.fbq('init', '587656480418310');
            window.fbq('track', 'PageView');
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-content">
                <img
                    src={icon}
                    alt="Cookie Icon"
                    className="cookie-banner-icon"
                />
                <h2 className="cookie-banner-title">Our website uses cookies</h2>
                <p className="cookie-banner-text">
                    Our website use cookies. By continuing, we assume your permission to deploy cookies as detailed in our{" "}
                    <a href={privacyPolicy} download="Privacy-Policy.pdf" className="cookie-banner-link">
                        Privacy Policy
                    </a>.
                </p>
                <div className="cookie-banner-button-container">
                    <button
                        className="cookie-banner-allow-button"
                        onClick={handleAllow}
                    >
                        Accept cookies
                    </button>
                    <button
                        className="cookie-banner-decline-button"
                        onClick={handleDecline}
                    >
                        Decline
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cookie;
